//取消安全模式
export const disableSafeMode = function () {
    let url = Fai.top.location.href || '';
    window.location.href = url.replace('_safeMode=true', '_safeMode=false');
};
